export class SqafSettingItem {
	public static readonly valueCount = 5;
	constructor(public name: string, public marketerId: number, public values: [any, any, any, any, any]) { }

	/**
	 *
	 * @param index 0-4
	 */
	public getValue = (index: number) => {
		if (index < 0 || index >= SqafSettingItem.valueCount) {
			throw new Error("Index out of range in sqaf setting item");
		}

		return this.values[index];
	}

	/**
	 *
	 * @param index 0-4
	 */
	public getValueOrDefaultIfNullOrUndefined = (index: number, defaultValue: any) => {
		let value = this.getValue(index);
		return value == null ? defaultValue : value;
	}

	/**
	 *
	 * @param index 0-4
	 */
	public getValueByType = <T>(index: number, defaultValue: T, fn: (val: any) => T) => {
		let value = this.getValue(index);
		return value == null ? defaultValue : fn(value);
	}

	/**
	 *
	 * @param index 0-4
	 */
	public getBoolean = (index: number = 0, defaultValue: boolean = false) => {
		return this.getValueByType(index, defaultValue, (val) => {
			let isTrueValue = val === "true" || val === true;
			let isFalseValue = val === "false" || val === false;

			return isTrueValue ? true : (isFalseValue ? false : defaultValue);
		});
	}

	/**
	 *
	 * @param index 0-4
	 */
	public getInt = (index: number = 0, defaultValue: number = 0) => {
		return this.getValueByType(index, defaultValue, (val) => {
			let parsedValue: number = parseInt(val);
			return isNaN(parsedValue) ? defaultValue : parsedValue;
		});
	}

	/**
	 *
	 * @param index 0-4
	 */
	public getFloat = (index: number = 0, defaultValue: number = 0.0) => {
		return this.getValueByType(index, defaultValue, (val) => parseFloat(val));
	}

	/**
	 *
	 * @param index 0-4
	 */
	public getString = (index: number = 0, defaultValue: string = "") => {
		return this.getValueByType(index, defaultValue, (val) => val == null ? null : String(val));
	}
}